import angular from 'angular';

import HttpService from './http.service';
import ApiService from './api.service';

export default angular
    .module('common.service.communication', [])
    .service('httpService', HttpService)
    .service('apiService', ApiService);



// WEBPACK FOOTER //
// ./src/common/service/communication/index.js